/**
 * [roundPriceUp, roundPriceDown] we need to do this calculation because prices are returned as cents
 * and when we multiply the price by conversion rate, we get a decimal amount
 * For example: $560 * 132.25397 (conversion for JPY) = 74062.2232
 * Then we need to round 74062.2232 to 74063 and then convert it into dollars -> 740.63
 * Finally we round it up to 741 and multiply it by 100 (74100) to get the cents value again in order
 * to pass it to LocalizedCurrency
 * @param price: number
 * @param currencyConversionRate: number
 */

export const convertPriceAndRoundUp = (price: number, currencyConversionRate: number) => {
  if (
    typeof price !== 'number' ||
    typeof currencyConversionRate !== 'number' ||
    !currencyConversionRate
  ) {
    return;
  }

  return Math.ceil((price * currencyConversionRate) / 100) * 100;
};

export const convertPriceAndRoundDown = (price: number, currencyConversionRate: number) => {
  if (
    typeof price !== 'number' ||
    typeof currencyConversionRate !== 'number' ||
    !currencyConversionRate
  ) {
    return;
  }

  return Math.floor((price * currencyConversionRate) / 100) * 100;
};
